<script lang="ts">
	import { showLoadingBackdrop } from '$lib/client/store';
	import { browser } from '$app/environment';
	let shown = false;
	export function show() {
		showLoadingBackdrop.set(true);
	}
	export function hide() {
		showLoadingBackdrop.set(false);
	}
	showLoadingBackdrop.subscribe((val) => {
		if (browser) {
			if (val) {
				document.getElementsByTagName('body')[0].style.overflow = 'hidden';
				shown = true;
			} else {
				document.getElementsByTagName('body')[0].style.overflow = 'visible';
				shown = false;
			}
		}
	});
</script>

{#if shown}
	<div
		id="loadingDiv"
		class="loading-backdrop"
		style="opacity: 0.4; background-color: rgb(0, 0, 0);"
	/>
	<div class="loading-full loading-spinner position-fixed">
		<div class="spinner-border loading-icon" />
		<span class="loading-text">Loading...</span>
	</div>
{/if}
